import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import { setIsExistsInStripe, setUsersList } from "../../Redux/UserSlice";
import StripeService from "../../Services/http/StripeService";
import UserService from "../../Services/http/UserService";

export const getUsersList = async (dispatch) => {
  dispatch(setIsActiveSpinner(true));
  const response = await UserService.getUsersList();
  if (response && response["message"] === "success") {
    dispatch(setUsersList(response["users"]));
  }
  dispatch(setIsActiveSpinner(false));
};

export const deleteUserDB = async (dispatch, userId) => {
  dispatch(setIsActiveSpinner(true));
  const response = await UserService.deleteUser(userId);
  getUsersList(dispatch);
  if (!response || response["message"] !== "success") {
    if (response['message']=="email_exists")
    alert("Email already exist");
    else
    alert("Error")
  }
  dispatch(setIsActiveSpinner(false));
};

export const activeUser = async (dispatch, userId) => {
  dispatch(setIsActiveSpinner(true));
  const response = await UserService.activeUser(userId, true);
  getUsersList(dispatch);
  if (!response || response["message"] !== "success") {
    alert("error");
  }
  dispatch(setIsActiveSpinner(false));
};

export const getUserDetails = async (dispatch, userId) => {
  dispatch(setIsActiveSpinner(true));
  const response = await UserService.getUserDetails(userId);
  dispatch(setIsActiveSpinner(false));
  return response["user"];
};

export const createUser = async (dispatch, userData) => {
  dispatch(setIsActiveSpinner(true));
  const response = await UserService.createUser(userData);
  if (!response || response["message"] !== "success") {

    if (response['message']=="email_exists") {
      alert("Email already exist");
    } else {
      alert("error");
    }
  }
  dispatch(setIsActiveSpinner(false));
  return response;
};

export const updateUser = async (dispatch, userId, userData) => {
  dispatch(setIsActiveSpinner(true));
  const response = await UserService.updateUser(userId, userData);
  if (!response || response["message"] !== "success") {
    alert("error");
  }
  dispatch(setIsActiveSpinner(false));
  return response;
};


export const checkIsExistsUserInStripe = async (dispatch, userId=null) => {
  dispatch(setIsActiveSpinner(true));
  const response = await UserService.checkIsExistsUserInStripe(userId);
  if (!response || !response["success"]) {
    alert(response? response['error']: 'error');
  } else {
    dispatch(setIsExistsInStripe(response["is_exists_in_stripe"]));
  }
  dispatch(setIsActiveSpinner(false));
};


export const createInvoice = async (dispatch, userId) => {
  dispatch(setIsActiveSpinner(true));
  const response = await StripeService.createBillingInvoice(userId);
  if (!response || !response["success"]) {
    alert(response? response['error']: 'error');
  } else {
    alert("success");
  }
  dispatch(setIsActiveSpinner(false));
};

export const chargeCustomer = async (dispatch, userId) => {
  dispatch(setIsActiveSpinner(true));
  const response = await StripeService.chargeCustomer(userId);
  if (!response || !response["success"]) {
    let message = ''
    if (!response) {
      message = 'error';
    } else if (response['error'] === 'no_invoice_to_pay') {
      message = 'No unpaid invoice found';
    } else if (response['error'] === 'invoice_already_paid') {
      message = 'The last invoice was paid by the customer';
    } else if (response['error'] === 'no_default_payment_method') {
      message = 'There is no default payment method';
    } else {
      message = response['error'];
    }
    alert(message);
  } else {
    alert("success");
  }
  dispatch(setIsActiveSpinner(false));
};


export const getUserAccountIdByAccountId = async (accountId) => {
  const response = await UserService.getUserAccountIdByAccountId(accountId);
  return response["user_id"];
};